import React from 'react';
import PropTypes from 'prop-types';

import MilestonesDetail from './Charts/MilestonesDetail';
import MilestonesMetric from './Charts/MilestonesMetric';
import MilestonesSummaryView from './Charts/MilestoneSummaryView';
import MilestonesEngagementTable from './Charts/MilestonesEngagementTable';

const Milestones = ({engagementMetrics}) => {
	const milestonesData = engagementMetrics.length > 0 ? _.flatten(engagementMetrics.map((item) => item.mS)) : [];

	return (
		<>
			<MilestonesSummaryView milestonesData={milestonesData} />
			<MilestonesDetail milestonesData={milestonesData} />
			<MilestonesMetric engagementMetrics={engagementMetrics} />
			<MilestonesEngagementTable engagementMetrics={engagementMetrics} />
		</>
	);
};

Milestones.defaultProps = {
	engagementMetrics: []
};

Milestones.propTypes = {
	engagementMetrics: PropTypes.arrayOf(
		PropTypes.shape({
			cRAccepted: PropTypes.number,
			cRDue3: PropTypes.number,
			cRDue5: PropTypes.number,
			cRDue10: PropTypes.number,
			cRDue30: PropTypes.number,
			cRDueTom: PropTypes.number,
			cRNotSent: PropTypes.number,
			cROD: PropTypes.number,
			cRPendResp: PropTypes.number,
			cRReceived: PropTypes.number,
			cRRetrn: PropTypes.number,
			cRTotal: PropTypes.number,
			cTComplSend: PropTypes.number,
			cTNotSent: PropTypes.number,
			cTOD: PropTypes.number,
			cTPartialSend: PropTypes.number,
			cTRetrn: PropTypes.number,
			cTTotal: PropTypes.number,
			cTUnlinkTot: PropTypes.number,
			conTaskClo: PropTypes.number,
			conTaskInProg: PropTypes.number,
			conTaskInRev: PropTypes.number,
			conTaskOpen: PropTypes.number,
			conTaskTotal: PropTypes.number,
			conTested: PropTypes.number,
			conTotal: PropTypes.number,
			defDesign: PropTypes.number,
			defOper: PropTypes.number,
			defOperAndDes: PropTypes.number,
			engDes: PropTypes.string,
			engId: PropTypes.number,
			engKey: PropTypes.number,
			gAType: PropTypes.number,
			hasAPEQRSO: PropTypes.bool,
			hasAPPICSO: PropTypes.bool,
			hasCRAEQRSO: PropTypes.bool,
			hasCRAPICSO: PropTypes.bool,
			isEQRCRASODlyd: PropTypes.bool,
			isEQREng: PropTypes.bool,
			isEQRInv: PropTypes.bool,
			isPartAPSODlyd: PropTypes.bool,
			isPartCRASODlyd: PropTypes.bool,
			isPartInvDlyd: PropTypes.bool
		})
	)
};

export default Milestones;
